// Version : 0.0.1
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last ADD : Removed the unused 'line' and 'AutoLoan Index'
// MODFIED DATA : 01-08-2025
/* eslint-disable import/no-anonymous-default-export */
import PreCloseLoanActionTypes from './pre-close-loan.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	// GET PRE CLOSE LOAN MEMBER LIST
	getPreCloseLoanMemberListArr: [],
	fetchPreCloseLoanMemberListResp: null,
	// UPDATE PRE CLOSE LOAN MEMBER
	updatePreCloseLoanMemberResp: null,
	// GET PRE CLOSE LOAN MEMBER
	getBranchEODArr: [],
	getBranchEODStatus: null,
	// REVERT PRE CLOSE LOAN MEMBER
	revertPreCloseLoanMemberListStatus: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/*********** GET PRE CLOSE LOAN MEMBER REPORT LIST START ************************ */
		case PreCloseLoanActionTypes.FETCH_PRE_CLOSE_LOAN_LIST_SUCCESS:
			return {
				...state,
				getPreCloseLoanMemberListArr: docodeHexResponse(
					action.payload,
					'fetchPreCloseMemberListKey',
				),
				fetchPreCloseLoanMemberListResp: action.payload,
			};

		case PreCloseLoanActionTypes.FETCH_PRE_CLOSE_LOAN_LIST_FAILURE:
			return { ...state, fetchPreCloseLoanMemberListResp: action.payload };

		case PreCloseLoanActionTypes.FETCH_PRE_CLOSE_LOAN_LIST_RESPONSE_CHANGED:
			return { ...state, fetchPreCloseLoanMemberListResp: null };
		/*********** GET PRE CLOSE LOAN MEMBER REPORT LIST END ************************ */

		/*********** UPDATE PRE CLOSE LOAN MEMBER REPORT LIST START ************************ */
		case PreCloseLoanActionTypes.UPDATE_PRE_CLOSE_LOAN_LIST_SUCCESS:
			return {
				...state,
				updatePreCloseLoanMemberResp: action.payload,
			};

		case PreCloseLoanActionTypes.UPDATE_PRE_CLOSE_LOAN_LIST_FAILURE:
			return { ...state, updatePreCloseLoanMemberResp: action.payload };

		case PreCloseLoanActionTypes.UPDATE_PRE_CLOSE_LOAN_LIST_CHANGED:
			return { ...state, updatePreCloseLoanMemberResp: null };
		/*********** UPDATE PRE CLOSE LOAN MEMBER REPORT LIST END ************************ */

		/*********** GET BRANCH EOD START ************************ */
		case PreCloseLoanActionTypes.GET_BRANCH_EOD_SUCCESS:
			return {
				...state,
				getBranchEODArr: docodeHexResponse(
					action.payload,
					'GetBranchEODExistPreCloseDetailsKey',
				),
				getBranchEODStatus: action.payload,
			};

		case PreCloseLoanActionTypes.GET_BRANCH_EOD_FAILURE:
			return {
				...state,
				getBranchEODStatus: action.payload,
			};

		case PreCloseLoanActionTypes.GET_BRANCH_EOD_CHANGED:
			return { ...state, getBranchEODStatus: null };

		/*********** GET BRANCH EOD END ************************ */

		/** *********************  START REVERT PreCloseLoan MEMBER REPORT LIST  ******************** */
		case PreCloseLoanActionTypes.REVERT_PRE_CLOSE_LOAN_LIST_SUCCESS:
			return {
				...state,
				revertPreCloseLoanMemberListStatus: action.payload,
			};

		case PreCloseLoanActionTypes.REVERT_PRE_CLOSE_LOAN_LIST_FAILURE:
			return { ...state, revertPreCloseLoanMemberListStatus: action.payload };

		case PreCloseLoanActionTypes.REVERT_PRE_CLOSE_LOAN_LIST_CHANGED:
			return { ...state, revertPreCloseLoanMemberListStatus: null };
		/** *********************  END REVERT PreCloseLoan MEMBER REPORT LIST  ******************** */
		default:
			return state;
	}
};
